import { ButtonMui } from 'src/components/ButtonMui'
import { SelectMui } from 'src/components/SelectMui'
import TextFieldMui from 'src/components/TextFieldMui'
import styled from 'styled-components'

export const ContainerForm = styled.form`
    display: flex;
    flex-direction: column;
    gap: 0.9rem;
    width: 100%;
    margin: 1.3rem 0 0 0;
`

export const ContainerSelectFilters = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.9rem;
`

export const ContainerTextArea = styled.div`
    display: flex;
    gap: 0.9rem;
`

export const CustomTextArea = styled(TextFieldMui)`
    margin: 0 !important;
    width: 38.6rem !important;
    height: 3.8rem !important;

    & input {
        height: 1.5rem !important;
    }
`
export const CustomButton = styled(ButtonMui)`
    width: 12rem;    
    height: 2.5rem !important;
    margin: 0 !important;
`
export const CustomTextField = styled(TextFieldMui)`
    margin: 0 !important;
    width: 32.8rem !important;
    height: 2.5rem !important;

    & input {
        height: 1.5rem !important;
    }
`

export const CustomSelect = styled(SelectMui)`
    width: 20rem;    
    margin: 0 !important;
    height: 2.5rem !important;
`
